import { splitMoney } from '../Results/utils';
import { useConfig } from '../context';
export var getFormattedAmount = function (money, multiplyBy, roundType) {
    if (multiplyBy === void 0) { multiplyBy = 1; }
    var roundMoneyAmount = useConfig().global.roundMoneyAmount;
    var amount = money === null || money === void 0 ? void 0 : money.amount;
    if (!amount) {
        return '';
    }
    if (roundType === 'ceil') {
        amount = Math.ceil(amount);
    }
    else if (roundType === 'floor') {
        // || (money?.amount?.toString(10).length >= 6 && money?.amount % 1 !== 0)) { что-то весьма странное было
        amount = Math.floor(amount);
    }
    else if (roundMoneyAmount) {
        amount = Math.round(amount);
    }
    amount *= multiplyBy;
    return splitMoney(amount, 2).join(' ');
};
